<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    },

    options: {
      type: Object,
      default: null
    },

    drillOption: {
      default: null
    }
  },

  data () {
    return {
      selectedData: {}
    }
  },

  mounted () {
    setTimeout(() => {
      this.renderChart(this.chartData, {
        onClick: this.click,
        onHover: (_, dataset) => {
          if (!dataset.length) {
            this.selectedData = {}
          }
        },
        tooltips: {
          xPadding: 10,
          yPadding: 8,
          caretPadding: 15,
          bodyFontFamily: 'Roboto',
          titleFontFamily: 'Roboto',
          cornerRadius: 5,
          backgroundColor: 'rgba(120,120,120,.85)',
          mode: 'nearest',
          callbacks: {
            footer: (label, dataset) => {
              if (this.options.scales.xAxes[0].stacked) {
                this.selectedData.value = dataset.datasets[label[0].datasetIndex].label
                this.selectedData.groupment = dataset.labels[label[0].index].toLowerCase()
              } else {
                this.selectedData.groupment = label[0].label
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.chartData ? this.chartData.datasets.length <= 5 : false,
          position: 'bottom',
          align: 'start',
          labels: {
            fontFamily: 'Roboto'
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                display: true
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }
          ]
        },
        ...this.options
      })
    }, 500)
  },

  methods: {
    click () {
      if (this.selectedData) {
        this.$emit('selection', {
          ...this.selectedData,
          type: this.drillOption
        })
      }
    }
  }
}
</script>

<style scoped>
  #bar-chart {
    height: 290px;
  }
</style>
